module.exports = __webpack_public_path__ + "img/fullCrossCorrelation.1440c394.jpg";